import { get as _get } from "lodash";
import * as kondor from "kondor-js";
// eslint-disable-next-line
import MyKoinosWallet from "@roamin/my-koinos-wallet-sdk";
import { CONFIG_BASE } from "../constants/configs";
import { defaultProvider } from "./contracts";
import { initializeWalletConnect, WALLET_CONNECT_METHODS } from "./wallets";
import storage from "./storage";

export const MKW_CONNECTOR_URL = CONFIG_BASE.wallet.mkw_connector_url;

/**
 * Returns the wallet saved by the last connection, or null
 */
export const getStoredSession = () => {
  try {
    const wallet = JSON.parse(storage.getItemDevice("wallet"));
    const walletName = JSON.parse(storage.getItemDevice("wallet_name"));
    return wallet && walletName ? { wallet, walletName } : null;
  } catch (error) {
    return null;
  }
};

/**
 * Reconnects the saved wallet and returns its provider, signer and instance
 * Throws when the wallet can not be restored without user interaction
 */
export const restoreWalletSession = async ({ wallet, walletName }) => {
  const address = _get(wallet, "[0].address", "");
  switch (walletName) {
    case "kondor":
      return {
        provider: defaultProvider,
        signer: kondor.getSigner(address, { providerPrepareTransaction: defaultProvider }),
        instance: null,
      };
    case "mkw": {
      const mkw = new MyKoinosWallet(MKW_CONNECTOR_URL);
      const connected = await mkw.connect();
      if (!connected) {
        throw new Error("MKW_NOT_CONNECTED");
      }
      return {
        provider: await mkw.getProvider(),
        signer: await mkw.getSigner(address),
        instance: mkw,
      };
    }
    case "walletconnect": {
      const walletConnectKoinos = initializeWalletConnect();
      // connect() opens the pairing modal when there is no session, only an existing one is restored
      const sessions = await walletConnectKoinos.web3Modal.getSessions();
      if (!sessions.length) {
        throw new Error("WALLETCONNECT_NO_SESSION");
      }
      const chainId = CONFIG_BASE.wallet.walletconnect_network_id;
      const accounts = await walletConnectKoinos.connect([chainId], [...WALLET_CONNECT_METHODS]);
      if (!accounts.length) {
        throw new Error("WALLETCONNECT_NO_ACCOUNTS");
      }
      return {
        provider: defaultProvider,
        signer: walletConnectKoinos.getSigner(accounts[0], defaultProvider, chainId),
        instance: walletConnectKoinos,
      };
    }
    default:
      throw new Error("UNKNOWN_WALLET");
  }
};
